/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Inventory_By_HolderInputs */



/**
* | output |
* | --- |
* | "By holder" |
*
* @param {Promo_Inventory_By_HolderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_inventory_by_holder = /** @type {((inputs?: Promo_Inventory_By_HolderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Inventory_By_HolderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Par détenteur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por poseedor")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Por detentor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per detentore")
	return /** @type {LocalizedString} */ ("By holder")
});